import { LotacaoAgendaSelectFieldModel } from 'components/form'
import { CriarAgendamentoConsultaCompartilhadaInput, GarantiaAcessoAgendarConsultaInput } from 'graphql/types.generated'
import { convertAgendarConsulta } from 'view/atendimentos/detail/soap/finalizacao/components/agendar-consulta/converter-agendarConsultaAtendimento'

import { GarantiaAcessoAgendaModel } from './GarantiaAcessoAgendarConsultaModalForm'

export const convertModelToInput = (
  values: GarantiaAcessoAgendaModel,
  garantiaAcessoId: ID,
  videochamadaUuid: string,
  isConsultaCompartilhada: boolean,
  horarioFinalEnabled: boolean = false
): GarantiaAcessoAgendarConsultaInput => {
  const commonFieldInput: GarantiaAcessoAgendarConsultaInput = { garantiaAcessoId: garantiaAcessoId }
  if (isConsultaCompartilhada) {
    return {
      ...commonFieldInput,
      agendamentoConsultaCompartilhadaInput: convertConsultaCompartilhadaToInput(
        values.agendamentoConsultaCompartilhadaInput,
        values.lotacaoResponsavel,
        videochamadaUuid
      ),
    }
  } else {
    return {
      ...commonFieldInput,
      agendamentoConsultaInput: convertAgendarConsulta(values.agendamentoConsultaInput, horarioFinalEnabled),
    }
  }
}

const convertConsultaCompartilhadaToInput = (
  values: GarantiaAcessoAgendaModel['agendamentoConsultaCompartilhadaInput'],
  lotacaoResponsavel: LotacaoAgendaSelectFieldModel,
  videochamadaUuid: string
): CriarAgendamentoConsultaCompartilhadaInput => ({
  horarioInicial: Number(values.horario.inicial),
  horarioFinal: Number(values.horario?.final),
  observacoes: values.observacoes,
  lotacaoId: lotacaoResponsavel.id,
  lotacaoParticipanteId: values.lotacaoConvidada.id,
  videochamadaUuid: videochamadaUuid,
  enviarEmailCidadao: true,
})
